import { ResetPasswordReq, SupertokensAuthApiReq } from '@/types';
import { getOrCreateDeviceId } from '@/utils/deviceId';
import client from './client';

async function register(reqData: SupertokensAuthApiReq) {
  const { data } = await client.post(`/api/auth/signup`, reqData);
  return data;
}

async function login(reqData: SupertokensAuthApiReq) {
  const deviceId = getOrCreateDeviceId();

  const { data } = await client.post(`/api/auth/signin`, reqData, {
    headers: deviceId
      ? {
          'x-device-id': deviceId,
        }
      : undefined,
  });
  return data;
}

async function fetchUserData() {
  const { data } = await client.get(`/user`);
  return data;
}

async function forgot(reqData: SupertokensAuthApiReq) {
  const { data } = await client.post(`/api/auth/user/password/reset/token`, reqData);
  return data;
}

async function reset(reqData: ResetPasswordReq) {
  const { data } = await client.post(`/api/auth/user/password/reset`, reqData);
  return data;
}

export const users = {
  register,
  login,
  fetchUserData,
  forgot,
  reset,
};
